import localforage = require('localforage');
import { IScript } from '../models/IScript';

function getScriptDraftKey(scriptId: string) {
    return `script-draft-${scriptId}`;
}

const draftStore = localforage.createInstance({
    name: "scriptDrafts"
});


const scriptDraftService = {

    hasDraft: async function (scriptId: string) {
        var scriptDraftKey = getScriptDraftKey(scriptId);

        if (!scriptId) {
            return false;
        }

        const value = await draftStore.getItem(scriptDraftKey);

        return value !== null;
    },

    getScriptText: async function (script: IScript) {
        var scriptTextFromLs = null;
        var scriptDraftKey = getScriptDraftKey(script.scriptId);

        if (!script.scriptId) {
            return '';
        }

        scriptTextFromLs = await draftStore.getItem(scriptDraftKey)

        return scriptTextFromLs === null ? script.text : scriptTextFromLs;
    },

    saveScriptDraft: async function (scriptId: string, scriptText: string) {
        var scriptDraftKey;

        if (!scriptId) {
            return;
        }

        scriptDraftKey = getScriptDraftKey(scriptId);
        draftStore.setItem(scriptDraftKey, scriptText).catch(function (err) {
            console.log(err);
        });;
    },

    removeDraft: async function (scriptId: string) {
        var scriptDraftKey = getScriptDraftKey(scriptId);
        await draftStore.removeItem(scriptDraftKey);
    }
};
export default scriptDraftService;